import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { getInvoices } from './actions'
import InvoicesTable from './invoice-table'
import { lang } from '../../strings'
import { trackEvent, INVOICE, LOAD } from '../../utils/analytics'

class Invoices extends Component {
  constructor(props) {
    super(props)

    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      collapsed: true,
    }
  }

  componentWillMount() {
    const { dispatch, invoices } = this.props

    if (invoices.isEmpty()) {
      dispatch(getInvoices())
    }
  }

  componentDidMount() {
    trackEvent(INVOICE, LOAD)
  }

  render() {
    let { appState, invoices } = this.props
    let { networkProgress } = appState.toJS()
    let { collapsed } = this.state

    let invoiceArray = collapsed ? invoices.take(12).toJS() : invoices.toJS()

    return (
      <div>
        <h2>{lang.invoices.title}</h2>
        {networkProgress ? (
          <p>{lang.invoices.loading}</p>
        ) : (
          <div>
            <p>{lang.invoices.intro}</p>
            <InvoicesTable invoices={invoiceArray} />
            <br />
            {collapsed ? (
              <div className='mp-expand'>
                <a href='#' className='button' onClick={this.showAll}>
                  {lang.invoices.showAll}
                </a>
              </div>
            ) : null}
          </div>
        )}
      </div>
    )
  }

  showAll = ev => {
    ev.preventDefault()
    this.setState({ collapsed: false })
  }
}

function propProvider(reduxState, props) {
  const { appState, invoices } = reduxState

  return {
    appState,
    invoices,
  }
}

export default connect(propProvider)(Invoices)
